import axios from 'axios'
const BASE_API_URL = process.env.REACT_APP_API_URL
//=====================Item URL======================
export const GET_ALL_Vehicle_List = `${BASE_API_URL}/Vehicle/Vehicle_GetList` //Get List
export const CREATE_Vehicle = `${BASE_API_URL}/Vehicle/Vehicle_AddDetails` //Add
export const UPDATE_Vehicle = `${BASE_API_URL}/Vehicle/Vehicle_UpdateDetails` //Update
export const UPDATE_Vehicle_BY_Vehicle_ID = `${BASE_API_URL}/Vehicle/Vehicle_GetBy_VehicleID` //Grt By Id
export const IS_ACTIVE_Vehicle = `${BASE_API_URL}/Vehicle/Vehicle_Updates_Isactive` //Iss Active
export const DELETE_Vehicle = `${BASE_API_URL}/Vehicle/Vehicle_Delete_Details` //Delete

// ============================================================================
export function GetVehicleListAPI() {
  return axios.get(GET_ALL_Vehicle_List)
}
// ============================================================================
export function CreateVehicleAPI(
  vehicleModelID: number,
  vehicleMakeID: number,
  customerID: number,
  vehicleColor: string,
  vehicleNo: string,
  isActive: boolean,
  createBy: number,
  ipAddress: string
) {
  return axios.post(CREATE_Vehicle, {
    vehicleModelID,
    vehicleMakeID,
    customerID,
    vehicleColor,
    vehicleNo,
    isActive,
    createBy,
    ipAddress,
  })
}
// ============================================================================
export function UpdateVehicleAPI(
  vehicleID: number,
  vehicleModelID: number,
  vehicleMakeID: number,
  customerID: number,
  vehicleColor: string,
  vehicleNo: string,
  isActive: boolean,
  updateBy: number,
  ipAddress: string
) {
  return axios.post(UPDATE_Vehicle, {
    vehicleID,
    vehicleModelID,
    vehicleMakeID,
    customerID,
    vehicleColor,
    vehicleNo,
    isActive,
    updateBy,
    ipAddress,
  })
}
// ============================================================================
export function GetVehicleByVehicleIDAPI(vehicleID: number) {
  return axios.post(UPDATE_Vehicle_BY_Vehicle_ID, {vehicleID})
}
// ============================================================================
export function DeleteVehicleAPI(vehicleID: number) {
  return axios.post(DELETE_Vehicle, {vehicleID})
}
// ============================================================================
export function IsActiveVehicleAPI(vehicleID: number, isActive: boolean) {
  return axios.post(IS_ACTIVE_Vehicle, {vehicleID, isActive})
}
